import { DefaultFooter } from '@ant-design/pro-layout';
import { useTranslation } from 'react-i18next';

import Settings from '../../../../config/defaultSettings';

export default () => {
  const { t } = useTranslation();

  return (
    <DefaultFooter
      copyright={`${new Date().getFullYear()} ${t('produced_by_blueVision_technology_department')}`}
      links={[{ key: 'home', title: Settings.title, href: '' }]}
    />
  );
};
